module.exports = __webpack_public_path__ + "img/hp-ak-green.2d3f04ee.png";